import { gql, useQuery } from '@apollo/client'

export enum AnnouncementType {
  NEWS = 'News',
  FEATURE = 'Feature',
  OFFER = 'Offer',
}

export interface Announcement {
  id: string
  updatedAt: string
  title: string
  content: string
  type: AnnouncementType
  publishedAt: string
  expiresAt?: string | null
  ctaLabel?: string | null
  ctaUrl?: string | null
}

interface PublishedAnnouncementsData {
  publishedAnnouncements: Announcement[]
}

export const PUBLISHED_ANNOUNCEMENTS = gql`
  query PublishedAnnouncements {
    publishedAnnouncements {
      id
      updatedAt
      title
      content
      type
      publishedAt
      expiresAt
      ctaLabel
      ctaUrl
    }
  }
`

export const usePublishedAnnouncementsQuery = () => useQuery<PublishedAnnouncementsData>(PUBLISHED_ANNOUNCEMENTS, {
  fetchPolicy: 'cache-and-network',
  pollInterval: 60_000,
})
